import { EntityApiDefinitionCard } from '@backstage/plugin-api-docs';
import { useEffect, useState } from 'react';
import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef, useEntity } from '@backstage/plugin-catalog-react';
import { EntityProvider } from '@backstage/plugin-catalog-react';
import { Entity } from '@backstage/catalog-model';
import { Typography } from '@material-ui/core';

export const ApiSpecContent = () => {
  const catalogApi = useApi(catalogApiRef);
  const [apiEntity, setEntity] = useState<Entity | undefined>(undefined);

  const apiProvider = useEntity();
  const apis = apiProvider.entity.spec?.providesApis;
  if (!Array.isArray(apis) || apis.length < 1) {
    return <Typography>No APIs provided by this component</Typography>;
  }

  // This assumes a component only provides 1 API, dealing with multiple APIs per component complicates things.
  // Let's cross that bridge when we come to it, which we might never do if we don't make the API specs more visible
  // and by doing so promote their use.
  const api = apis.at(0);
  if (typeof api !== 'string') throw new Error('Not a string');

  useEffect(() => {
    catalogApi
      .getEntityByRef({
        kind: 'API',
        namespace: apiProvider.entity.metadata.namespace || 'default',
        name: api,
      })
      .then(setEntity)
      .catch(err => console.error('Failed to fetch entity', err));
  }, [catalogApi]);

  if (!apiEntity) return <Typography>Loading...</Typography>;

  return (
    <EntityProvider entity={apiEntity}>
      <EntityApiDefinitionCard />
    </EntityProvider>
  );
};
